import type { InjectionKey, MaybeRef } from 'vue'

export const appChatIdInjectionKey = Symbol('appChatIdInjectionKey') as InjectionKey<MaybeRef<number>>
